import React, { Component } from 'react';
import { connect } from 'react-redux';
import dropin from 'braintree-web-drop-in';

import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import {
  getCregDiscountedAdminFee,
  getSubscriptionTypeForCreg,
} from '../../utils';
import {
  COST_SIMPLE,
  COST_STANDARD,
  COST_COSYND_ADMIN_FEE,
  CREG_LIMIT_FOR_PREMIUM_ANNUAL,
  COST_UNPUBLISHED_WORK,
  COST_PHOTOGRAPH_COLLECTION,
  COST_UNPUBLISHED_LITERARY_WORK,
  WORK_SUB_TYPE_LITERARY_WORK,
  WORK_SUB_TYPE_PHOTOGRAPH_COLLECTION,
  WORK_SUB_TYPE_PHOTOGRAPH_INDIVIDUAL,
  SPECIAL_CLIENTS_FOR_FREE_FEE,
  SPECIAL_REFERRER_IDS_FOR_FREE,
} from '../../constants';
import { Alert } from '../Common';
import _get from 'lodash/get';
import _reduce from 'lodash/reduce';

class Payment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      instance: null,
      cart: null,
      payLoading: false,
      fee: 0,
      usersWithReferrerId: [],
      hasRecalculatedAfterUsersLoad: false,
    };
  }

  componentWillMount() {
    const { fields, profile } = this.props;
    const referrer = _get(profile, 'referrer', '');

    if (referrer) {
      this.props.getUsersWithReferrerID(referrer);
    }

    if (!fields.type || fields.type === '') {
      this.props.router.push('/copyright-reg');
    } else {
      this.props.getClientToken();
      this.calculate();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { status, cregStatus, usersStatus } = nextProps;

    if (cregStatus !== this.props.cregStatus) {
      if (cregStatus === actionTypes.COREG_CREATE_SUCCESS) {
        this.setState({ payLoading: false }, () => {
          this.props.loadProfile();
          this.props.router.push('/copyright-reg/submit-form');
        });
      } else if (cregStatus === actionTypes.COREG_CREATE_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert('error', 'Copyright create failed. Please try again');
      }
    }

    if (status !== this.props.status) {
      if (status === actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
        this.props.changeCart({ simple: 0, standard: 0 });
        this.createCoreg();
      } else if (status === actionTypes.PAYMENT_TRANSACTION_ERROR) {
        this.setState({ payLoading: false });
        this.props.alert('error', 'Payment failed. Please try again');
      }
    } else {
      this.calculate();
    }

    // Recalculate if API call was successful and we haven't recalculated yet
    if (
      usersStatus === actionTypes.USERS_WITH_REFERRER_ID_GET_SUCCESS &&
      !this.state.hasRecalculatedAfterUsersLoad
    ) {
      this.setState({ hasRecalculatedAfterUsersLoad: true });
      this.calculate();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { clientToken, users } = this.props;
    const { instance } = this.state;

    // Check if users data has been loaded and we haven't recalculated yet
    if (
      users &&
      users.length > 0 &&
      !this.state.hasRecalculatedAfterUsersLoad
    ) {
      this.setState({ hasRecalculatedAfterUsersLoad: true });
      this.calculate();
    }

    // Alternative approach: Force recalculate if users data is available
    if (users && users.length > 0 && prevProps.users.length === 0) {
      this.calculate();
    }

    if (clientToken && !instance) {
      dropin.create(
        {
          authorization: clientToken,
          container: '#dropin-container',
          translations: {
            chooseAWayToPay: 'Choose a payment option below:',
          },
        },
        (err, instance) => {
          if (!err) {
            this.setState({ instance });
          }
        }
      );
    }
  }

  createCoreg() {
    const { fields, profile, coregTemp, subscription } = this.props;
    let planTypeValue = 'free';
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );

    if (
      this.isSpecialReferrer() ||
      SPECIAL_REFERRER_IDS_FOR_FREE[_get(profile, 'referrer', '')]
    )
      planTypeValue = 'premium';
    else planTypeValue = planType;

    const coreg = {
      user: profile.id,
      data: JSON.stringify(fields),
      is_success: false,
      tempId: coregTemp ? coregTemp.id : null,
      planType: planTypeValue,
    };
    this.props.createCoreg(coreg);
  }

  isSpecialClient() {
    const { profile } = this.props;
    const cregCount = parseInt(profile.creg_count, 10);
    const specialAccount = SPECIAL_CLIENTS_FOR_FREE_FEE.find(
      (client) => client.email === profile.email
    );

    return specialAccount && cregCount < specialAccount.cregCount;
  }

  isSpecialReferrer() {
    const { profile, users } = this.props;
    const referrer = _get(profile, 'referrer', '');

    if (!referrer) return false;

    const limitation =
      SPECIAL_REFERRER_IDS_FOR_FREE[_get(profile, 'referrer', '')];

    if (limitation && Number(_get(profile, 'creg_count', 0)) >= 1) {
      return false;
    }

    const usersWithReferrerIdCregCount = _reduce(
      users,
      (acc, user) => {
        return acc + Number(_get(user, 'creg_count', 0));
      },
      0
    );

    return (
      users && users.length > 0 && usersWithReferrerIdCregCount < limitation
    );
  }

  getFederalFee = (cart) => {
    const { fields } = this.props;

    if (this.isSpecialClient() || this.isSpecialReferrer()) return 0;

    if (fields.subType === WORK_SUB_TYPE_LITERARY_WORK) {
      // Selected "Literary Work" in Document
      if (fields.authors.length === 1 && fields.claimants.length === 1) {
        if (fields.workTitles.length > 1) {
          if (fields.published === false) {
            return COST_UNPUBLISHED_LITERARY_WORK;
          } else {
            return COST_STANDARD;
          }
        } else {
          return COST_STANDARD;
        }
      }
    }

    if (fields.workTitles.length > 1) {
      if (
        fields.subType === WORK_SUB_TYPE_PHOTOGRAPH_COLLECTION ||
        fields.subType === WORK_SUB_TYPE_PHOTOGRAPH_INDIVIDUAL
      ) {
        // Selected "Photograph Selection" in copyright-type
        return COST_PHOTOGRAPH_COLLECTION;
      }

      if (fields.published === false) {
        if (
          fields.subType === WORK_SUB_TYPE_PHOTOGRAPH_COLLECTION ||
          fields.subType === WORK_SUB_TYPE_PHOTOGRAPH_INDIVIDUAL
        ) {
          // Selected "Photograph Selection" in copyright-type
          return COST_PHOTOGRAPH_COLLECTION;
        }

        // Unpublished and multiple works
        return COST_UNPUBLISHED_WORK;
      }
    }

    return cart.simple > 0 ? COST_SIMPLE : COST_STANDARD;
  };

  calculate() {
    let {
      fields,
      profile,
      cart: { standard, simple },
    } = this.props;

    if (fields.workTitles && fields.authors) {
      if (fields.workTitles.length === 1 && fields.authors.length === 1) {
        if (
          fields.authors[0]['organization'] &&
          fields.authors[0]['organization'] !== ''
        ) {
          standard++;
        } else {
          simple++;
        }
      } else {
        standard++;
      }

      const fee = this.getAdminFee(profile.referrer);
      const federalFee = this.getFederalFee({ simple, standard });

      const total =
        simple * federalFee + standard * federalFee + (simple + standard) * fee;

      this.setState({
        cart: {
          simple,
          standard,
          total: total.toFixed(2),
        },
        fee,
      });
    }
  }

  getAdminFee = () => {
    const { profile, subscription } = this.props;
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );
    const cregCount = parseInt(profile.creg_count, 10);
    let adminFee = getCregDiscountedAdminFee(profile.referrer, planType);

    if (this.isSpecialClient() || this.isSpecialReferrer()) {
      return 0;
    }

    if (planType === 'premium' && cregCount < CREG_LIMIT_FOR_PREMIUM_ANNUAL) {
      adminFee = 0;
    }

    return adminFee;
  };

  handlePayment = () => {
    const { instance, cart, fee } = this.state;

    // Process purchase and create transaction
    this.props.hideAlert();

    if (instance && cart.total) {
      this.setState({ payLoading: true }, () => {
        this.props.alert(
          'info',
          'Payment is processing, please do not refresh page.'
        );
      });

      instance.requestPaymentMethod((err, payload) => {
        if (err) {
          console.error(err);
          this.setState({ payLoading: false });
          this.props.alert('error', 'Payment creation failed.');
        } else {
          const data = {
            nonce: payload.nonce,
            amount: cart.total.toString(),
            admin_fee_total: fee,
          };
          this.props.pay(data);
        }
      });
    }
  };

  handleNext() {
    const { status } = this.props;

    this.props.hideAlert();

    if (this.isSpecialClient() || this.isSpecialReferrer()) {
      this.props.changeCart({ simple: 0, standard: 0 });
      this.createCoreg();

      return;
    }

    if (status !== actionTypes.PAYMENT_TRANSACTION_SUCCESS) {
      this.props.alert('error', 'Please make a valid payment.');
    }
  }

  discountedPremiumUser = () => {
    const { profile, subscription } = this.props;
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );
    // const cregCount = parseInt(profile.creg_count, 10);

    // if (planType === 'premium' && cregCount < CREG_LIMIT_FOR_PREMIUM_ANNUAL) {
    if (planType === 'premium' && profile.referrer) {
      return true;
    }
    return false;
  };

  trialReferrerUser = () => {
    const { profile, subscription } = this.props;
    const { planType } = getSubscriptionTypeForCreg(
      profile.subscription_plan,
      subscription
    );

    if (planType !== 'premium' && profile.referrer) {
      return true;
    }
    return false;
  };

  renderCart() {
    const { cart } = this.state;

    if (!cart) return null;

    return (
      <div className="cart">
        <Alert
          messages={[
            'Please review your order below. If you leave this session without completing this step, your information will not be saved and your order will not be processed.',
            'Please note that you will be required to upload your content files after you have submitted your payment.',
          ]}
        />
        <ul>
          {cart.simple > 0 && (
            <li>
              Federal Filing Fee (${this.getFederalFee(cart)}) x {cart.simple}
              <br />
              {/* Simple Application (${this.getFederalFee(cart)}) x {cart.simple}<br /> */}
              {/* <i>- An application containing 1 work by 1 author.</i> */}
            </li>
          )}
          {cart.standard > 0 && (
            <li>
              Federal Filing Fee (${this.getFederalFee(cart)}) x {cart.standard}
              <br />
              {/* Standard Application (${this.getFederalFee(cart)}) x {cart.standard}<br />
                            <i>- An application containing multiple works by multiple authors.</i> */}
            </li>
          )}
          <li>
            Cosynd Administrative Fee (
            <span
              className={`standard-fee ${
                this.trialReferrerUser() || this.discountedPremiumUser()
                  ? 'removed-fee'
                  : ''
              }`}
            >
              ${COST_COSYND_ADMIN_FEE}
            </span>
            {(this.trialReferrerUser() ||
              this.isSpecialClient() ||
              this.isSpecialReferrer() ||
              this.discountedPremiumUser()) && (
              <span className="discount-fee">&nbsp;${this.getAdminFee()}</span>
            )}
            {/* {this.discountedPremiumUser() && <span className="discount-fee">&nbsp;$0</span>} */}
            ) x {cart.standard + cart.simple}
          </li>
        </ul>
        <p>
          <strong>
            Cart Total: <span className="pl4 text-green">${cart.total}</span>
          </strong>
        </p>
      </div>
    );
  }

  render() {
    const { payLoading } = this.state;

    return (
      <div className="complete-pay">
        <Heading text="Review and Checkout" />
        <div className="content">
          <div className="inner">
            {this.renderCart()}
            {!this.isSpecialClient() && !this.isSpecialReferrer() && (
              <div>
                <div id="dropin-container"></div>
                <div className="payment-action">
                  <button
                    id="payment-button"
                    disabled={payLoading}
                    onClick={this.handlePayment}
                  >
                    {payLoading ? 'Processing...' : 'Pay Now'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          {/* {
            this.isSpecialClient() ? (
              <NavButtons direction="next" next={() => this.handlePayment()} />
            ) : (
              <NavButtons direction="next" next={() => this.handleNext()} />
            )
          } */}
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  fields: state.coreg.fields,
  coregTemp: state.coreg.coregTemp,
  cart: state.coreg.cart,
  clientToken: state.payment.clientToken,
  status: state.payment.status,
  cregStatus: state.coreg.status,
  subscription: state.payment.subscription,
  users: state.users.users,
  usersStatus: state.users.status,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
  getClientToken: () => {
    dispatch(actions.clientToken());
  },
  pay: (options) => {
    dispatch(actions.pay(options));
  },
  changeCart: (cart) => {
    dispatch(actions.changeCart(cart));
  },
  createCoreg: (coreg) => {
    dispatch(actions.createCoreg(coreg));
  },
  loadProfile: () => {
    dispatch(actions.getProfile());
  },
  getUsersWithReferrerID: (referrer) => {
    dispatch(actions.getUsersWithReferrerID(referrer));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);



// WEBPACK FOOTER //
// src/components/Copyright/Payment.jsx